import servicesConfig from './services'

const getHeader = () => {
  return {
    channel: 'APP',
    source: 'WEB_USER',
    version: '2021-07-28',

    // add the translation language to headers (for translations API)
    // this header can be used by the servers to try and fetch the translations
    // available for any entry in the DB
    'x-translations-lang': localStorage.getItem('locale') || 'en-US',
  }
}

const host = servicesConfig.PerformanceMonitoringService as string

// Helper function to send beacon
const sendBeacon = (url: string, data: any) => {
  if (!navigator.sendBeacon) {
    console.warn('[Perf] SendBeacon not supported in this browser')
    return false
  }

  try {
    const payload = JSON.stringify({
      data,
      headers: getHeader(),
    })

    // Check payload size (64KB = 65536 bytes)
    if (payload.length > 65536) {
      console.warn('[Perf] Payload too large for sendBeacon:', payload.length, 'bytes')
      return false
    }

    const blob = new Blob([payload], {
      type: 'text/plain;charset=UTF-8',
    })
    return navigator.sendBeacon(url, blob)
  } catch (error) {
    console.error('[Perf] Failed to send beacon:', error)
    return false
  }
}

// Define service object with methods
const PerformanceMonitoringService = {
  logOperationExecutorMetrics: (body: any) => {
    sendBeacon(`${host}/1/operation-executor-logs`, body)
  },
}

export default PerformanceMonitoringService
